import React, { FC } from 'react';

import Copy from 'Src/components/Copy';

import styles from './CheckItemDetailButton.module.scss';

const sectionId = 'CheckItemDetailButton';

interface CheckItemDetailButtonProps {
  label: string;
  onClick: () => void;
}

const CheckItemDetailButton: FC<CheckItemDetailButtonProps> = ({ label, onClick }) => (
   
  <button
    className={styles.root}
    onClick={onClick}
  >
    <Copy className={styles.name}>{label}</Copy>       
  </button>
);

export { CheckItemDetailButton, sectionId };
export type { CheckItemDetailButtonProps };
